export default __webpack_public_path__ + "static/media/guesty_lite_step3.ce2b538c.png";